export var AfriexCurrencyCode;
(function (AfriexCurrencyCode) {
    AfriexCurrencyCode["NGN"] = "NGN";
    AfriexCurrencyCode["USD"] = "USD";
    AfriexCurrencyCode["GBP"] = "GBP";
    AfriexCurrencyCode["GIP"] = "GIP";
    AfriexCurrencyCode["EUR"] = "EUR";
    AfriexCurrencyCode["AUD"] = "AUD";
    AfriexCurrencyCode["RUB"] = "RUB";
    AfriexCurrencyCode["KES"] = "KES";
    AfriexCurrencyCode["UGX"] = "UGX";
    AfriexCurrencyCode["CAD"] = "CAD";
    AfriexCurrencyCode["GHS"] = "GHS";
    AfriexCurrencyCode["XAF"] = "XAF";
    AfriexCurrencyCode["ETB"] = "ETB";
    AfriexCurrencyCode["HTG"] = "HTG";
    AfriexCurrencyCode["XOF"] = "XOF";
    AfriexCurrencyCode["GNF"] = "GNF";
    AfriexCurrencyCode["EGP"] = "EGP";
    AfriexCurrencyCode["MXN"] = "MXN";
    AfriexCurrencyCode["CNY"] = "CNY";
    AfriexCurrencyCode["INR"] = "INR";
    AfriexCurrencyCode["PHP"] = "PHP";
    AfriexCurrencyCode["BRL"] = "BRL";
    AfriexCurrencyCode["UYU"] = "UYU";
    AfriexCurrencyCode["PKR"] = "PKR";
    AfriexCurrencyCode["RWF"] = "RWF";
    AfriexCurrencyCode["ZAR"] = "ZAR";
    AfriexCurrencyCode["TZS"] = "TZS";
    AfriexCurrencyCode["SLE"] = "SLE";
    // Liberian dollar and Djiboutian franc, added for PAPSS's four-corridor
    // UAT batch (2026-08-26) — see AfriexCountryCode.ts's LR/DJ.
    AfriexCurrencyCode["LRD"] = "LRD";
    AfriexCurrencyCode["DJF"] = "DJF";
    AfriexCurrencyCode["MZN"] = "MZN";
    AfriexCurrencyCode["MWK"] = "MWK";
    AfriexCurrencyCode["MGA"] = "MGA";
    AfriexCurrencyCode["SSP"] = "SSP";
    AfriexCurrencyCode["ZMW"] = "ZMW";
    AfriexCurrencyCode["BWP"] = "BWP";
    AfriexCurrencyCode["GMD"] = "GMD";
    AfriexCurrencyCode["CDF"] = "CDF";
    AfriexCurrencyCode["MAD"] = "MAD";
    AfriexCurrencyCode["HKD"] = "HKD";
    AfriexCurrencyCode["CHF"] = "CHF";
    AfriexCurrencyCode["NOK"] = "NOK";
    AfriexCurrencyCode["AED"] = "AED";
    AfriexCurrencyCode["SAR"] = "SAR";
    AfriexCurrencyCode["QAR"] = "QAR";
    AfriexCurrencyCode["KWD"] = "KWD";
    AfriexCurrencyCode["SGD"] = "SGD";
    AfriexCurrencyCode["NZD"] = "NZD";
    AfriexCurrencyCode["JPY"] = "JPY";
    AfriexCurrencyCode["KRW"] = "KRW";
    AfriexCurrencyCode["BDT"] = "BDT";
    AfriexCurrencyCode["IDR"] = "IDR";
    AfriexCurrencyCode["MYR"] = "MYR";
    AfriexCurrencyCode["THB"] = "THB";
    AfriexCurrencyCode["VND"] = "VND";
    AfriexCurrencyCode["TRY"] = "TRY";
    AfriexCurrencyCode["COP"] = "COP";
    AfriexCurrencyCode["PEN"] = "PEN";
    AfriexCurrencyCode["CLP"] = "CLP";
    AfriexCurrencyCode["ARS"] = "ARS";
    AfriexCurrencyCode["DZD"] = "DZD";
    AfriexCurrencyCode["TND"] = "TND";
    AfriexCurrencyCode["ZWL"] = "ZWL";
    AfriexCurrencyCode["NAD"] = "NAD";
    // Local currencies for the 8 non-SEPA IBAN countries added to
    // AfriexCountryCode (AZ, BA, BH, GE, IL, JO, KZ, MU) so
    // CountryCodeToCurrencyCodeMap has a real entry for each.
    AfriexCurrencyCode["AZN"] = "AZN";
    AfriexCurrencyCode["BAM"] = "BAM";
    AfriexCurrencyCode["BHD"] = "BHD";
    AfriexCurrencyCode["GEL"] = "GEL";
    AfriexCurrencyCode["ILS"] = "ILS";
    AfriexCurrencyCode["JOD"] = "JOD";
    AfriexCurrencyCode["KZT"] = "KZT";
    AfriexCurrencyCode["MUR"] = "MUR";
    AfriexCurrencyCode["KMF"] = "KMF";
    AfriexCurrencyCode["XCD"] = "XCD";
    AfriexCurrencyCode["AMD"] = "AMD";
    AfriexCurrencyCode["AOA"] = "AOA";
    AfriexCurrencyCode["BBD"] = "BBD";
    AfriexCurrencyCode["BIF"] = "BIF";
    AfriexCurrencyCode["BND"] = "BND";
    AfriexCurrencyCode["BOB"] = "BOB";
    AfriexCurrencyCode["BSD"] = "BSD";
    AfriexCurrencyCode["BTN"] = "BTN";
    AfriexCurrencyCode["BZD"] = "BZD";
    AfriexCurrencyCode["CRC"] = "CRC";
    AfriexCurrencyCode["CVE"] = "CVE";
    AfriexCurrencyCode["DOP"] = "DOP";
    AfriexCurrencyCode["ERN"] = "ERN";
    AfriexCurrencyCode["FJD"] = "FJD";
    AfriexCurrencyCode["GTQ"] = "GTQ";
    AfriexCurrencyCode["GYD"] = "GYD";
    AfriexCurrencyCode["HNL"] = "HNL";
    AfriexCurrencyCode["ISK"] = "ISK";
    AfriexCurrencyCode["JMD"] = "JMD";
    AfriexCurrencyCode["KGS"] = "KGS";
    AfriexCurrencyCode["KHR"] = "KHR";
    AfriexCurrencyCode["LAK"] = "LAK";
    AfriexCurrencyCode["LKR"] = "LKR";
    AfriexCurrencyCode["LSL"] = "LSL";
    AfriexCurrencyCode["MDL"] = "MDL";
    AfriexCurrencyCode["MNT"] = "MNT";
    AfriexCurrencyCode["MRU"] = "MRU";
    AfriexCurrencyCode["MVR"] = "MVR";
    AfriexCurrencyCode["NPR"] = "NPR";
    AfriexCurrencyCode["OMR"] = "OMR";
    AfriexCurrencyCode["PAB"] = "PAB";
    AfriexCurrencyCode["PGK"] = "PGK";
    AfriexCurrencyCode["PYG"] = "PYG";
    AfriexCurrencyCode["SBD"] = "SBD";
    AfriexCurrencyCode["SCR"] = "SCR";
    AfriexCurrencyCode["SRD"] = "SRD";
    AfriexCurrencyCode["STN"] = "STN";
    AfriexCurrencyCode["SZL"] = "SZL";
    AfriexCurrencyCode["TJS"] = "TJS";
    AfriexCurrencyCode["TMT"] = "TMT";
    AfriexCurrencyCode["TOP"] = "TOP";
    AfriexCurrencyCode["TTD"] = "TTD";
    AfriexCurrencyCode["UZS"] = "UZS";
    AfriexCurrencyCode["VUV"] = "VUV";
    AfriexCurrencyCode["WST"] = "WST";
})(AfriexCurrencyCode || (AfriexCurrencyCode = {}));
//# sourceMappingURL=AfriexCurrencyCode.js.map